import {Component, signal, computed} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {ToastModule} from 'primeng/toast';
import {TooltipModule} from 'primeng/tooltip';
import {TranslocoPipe} from '@jsverse/transloco';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {MultiTabStepBaseComponent} from '../../../../../../shared/tabs/multi-tab-step-base.component';
import {TabStatusEnum} from '../../../../../../shared/tabs/tab-status.model';
import {TabStatusDirective} from '../../../../../../shared/tabs/tab-status.directive';
import {ProjectChapterType, ProjectStepType} from '@frontend/shared';
import {PreviousStepIncompleteNoticeComponent} from '../../../../../../shared/components/previous-step-incomplete-notice/previous-step-incomplete-notice.component';
import {Step841ProviderResultsPriceListComponent} from './step-8-4-1-rfq-provider-results-price-list/step-8-4-1-provider-results-price-list.component';
import {Step842ProviderResultsDocumentsComponent} from './step-8-4-2-rfq-provider-results-documents/step-8-4-2-provider-results-documents.component';
import {CardTitleComponent} from '../../../../../../shared/components/header/card-title/card-title.component';
import {TabsUnsavedRevealDirective} from '../../../../../../shared/tabs/tabs-unsaved-reveal.directive';

@Component({
  imports: [
    FormsModule,
    ButtonModule,
    CardModule,
    ToastModule,
    TooltipModule,
    TranslocoPipe,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    PreviousStepIncompleteNoticeComponent,
    Step841ProviderResultsPriceListComponent,
    Step842ProviderResultsDocumentsComponent,
    CardTitleComponent,
    TabStatusDirective,
    TabsUnsavedRevealDirective,
  ],
  templateUrl: './step-8-4-provider-results.component.html',
})
export class Step84ProviderResultsComponent extends MultiTabStepBaseComponent {
  protected readonly priceListTabStatus = signal(TabStatusEnum.COMPLETED);
  protected readonly uploadedDocumentsTabStatus = signal(TabStatusEnum.COMPLETED);

  protected readonly isStepPrerequisiteCompleted = computed(() =>
    this.stepState.areStepsCompleted([
      {
        chapterId: ProjectChapterType.RFQ,
        stepId: ProjectStepType.RFQ_PROVIDER_INVITATION,
      },
    ]),
  );
}
